import { comments } from '@/mocks/comics';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">读者热评</h2>
            <p className="text-sm text-foreground-500">看看漫友们都在讨论什么</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {comments.map((comment, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                      <span className="text-xs text-foreground-400">{comment.time}</span>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                        {comment.comic}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
                    <div className="flex items-center gap-4">
                      <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                        <i className="ri-thumb-up-line"></i>
                        {comment.likes}
                      </span>
                      <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                        <i className="ri-chat-1-line mr-1"></i>回复
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}